import React from "react";
import { AppBar, Toolbar, Typography, IconButton } from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

//css
import GerenciarPedidosCss from "./styles";
const useStyles = GerenciarPedidosCss();

/**
 * @param {Object} param
 * @param {string=} param.title
 * @param {Function=} param.goBack
 */
export default ({ title, goBack }) => {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <AppBar position="static">
                <Toolbar>
                    {goBack && (
                        <IconButton
                            onClick={goBack}
                            edge="start"
                            className={classes.menuButton}
                            color="inherit"
                            aria-label="menu"
                        >
                            <ArrowBackIcon />
                        </IconButton>
                    )}
                    <Typography variant="h6" className={classes.title}>
                        {title}
                    </Typography>
                </Toolbar>
            </AppBar>
        </div>
    );
};
